var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { refreshTokenIfNeeded, redirectToLogin } from "./request-interceptor";
export const attachResponseInterceptor = (api) => {
    api.interceptors.response.use((response) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const data = response.data;
        // Handle 401/403 in response body (API returns success HTTP status but auth failed)
        if (data &&
            data.isSuccess === false &&
            (data.status === 401 || data.status === 403)) {
            const originalRequest = response.config;
            // If refresh token endpoint failed, redirect to login
            if ((_a = originalRequest.url) === null || _a === void 0 ? void 0 : _a.includes("refresh-access-token")) {
                redirectToLogin();
                return Promise.reject(new Error(data.message || "Session expired"));
            }
            // Skip retry for already retried requests
            if (originalRequest._retry) {
                redirectToLogin();
                return Promise.reject(new Error(data.message || "Unauthorized"));
            }
            // Try to refresh the token and retry the request
            const newToken = yield refreshTokenIfNeeded(api);
            if (newToken) {
                originalRequest._retry = true;
                if (originalRequest.headers) {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                }
                return api(originalRequest);
            }
            redirectToLogin();
            return Promise.reject(new Error(data.message || "Unauthorized"));
        }
        return response;
    }), (error) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const originalRequest = error.config;
        // Only handle 401 errors
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== 401 || !originalRequest) {
            return Promise.reject(error);
        }
        // If refresh token endpoint failed, redirect to login
        if ((_b = originalRequest.url) === null || _b === void 0 ? void 0 : _b.includes("refresh-access-token")) {
            redirectToLogin();
            return Promise.reject(error);
        }
        // Skip retry for already retried requests
        if (originalRequest._retry) {
            redirectToLogin();
            return Promise.reject(error);
        }
        // Try to refresh the token and retry the request
        const newToken = yield refreshTokenIfNeeded(api);
        if (newToken) {
            originalRequest._retry = true;
            if (originalRequest.headers) {
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
            }
            return api(originalRequest);
        }
        redirectToLogin();
        return Promise.reject(error);
    }));
    return api;
};
